import React, { useRef } from 'react';
import { AutoComplete } from 'antd';
import { BaseSelectRef } from 'rc-select';

interface BundleSelectProps {
    onSelect?: (value: string) => void;
    onChange?: (value: string) => void;
}

const BundleSelect: React.FC<BundleSelectProps> = props => {
    const { onSelect, onChange } = props;
    const options = [
        { label: 'Xiaomi Browser', value: 'com.mi.globalbrowser' },
        { label: 'Vivo Browser', value: 'com.vivo.browser' },
        { label: 'Huawei Browser', value: 'com.huawei.browser' },
        { label: 'Huawei Assistant', value: 'com.huawei.intelligent' },
        { label: 'Huawei Petal', value: 'com.huawei.hwsearch' },
        { label: 'Huawei AI Search Banner', value: 'com.huawei.search.banner' },
        { label: 'Huawei AI Search Newsfeed', value: 'com.huawei.search.newsfeed' },
        { label: 'Huawei Third Party Apps', value: 'third_party_apps' },
        { label: 'Huawei Internal Apps', value: 'internal_apps' },
    ];

    const selectEl = useRef<BaseSelectRef>(null);

    const onBundleSelect = (e: string) => {
        selectEl.current!.blur();
        if (onSelect) {
            onSelect(e);
        }
    };

    return (
        <AutoComplete
            style={{ width: 220 }}
            defaultValue={undefined}
            ref={selectEl}
            options={options}
            placeholder="Select or type bundle name"
            onChange={onChange}
            onSelect={onBundleSelect}
            filterOption={(input, option) => option!.value.toUpperCase().indexOf(input.toUpperCase()) !== -1}
            allowClear
        />
    );
};

export default BundleSelect;
